import {BiointelligentLinkType} from 'molbio/biointelligent-links/BiointelligentLinkConstants';
import * as Colors from 'ui-library/Colors';

// Linked item chip values
export const LINKED_ENTITY_CHIP_VERTICAL_PADDING = 1;
export const LINKED_ENTITY_CHIP_HORIZONTAL_PADDING = 2;
export const LINKED_ENTITY_CHIP_ICON_SIZE = 12;

// Colors
// Background color / 'annotation' color for part links is currently in PartsViewConstants.ts
export const PART_LINK_ARROW_COLOR = '#CFE6E8';
export const HIGHLIGHT_STROKE_COLOR = Colors.GRAY;
export const HIGHLIGHT_FILL_OPACITY = 0.75;
export const HIGHLIGHT_STROKE_WIDTH = 1;
export const HIGHLIGHT_STROKE_OPACITY = 1;

// Values for links to proteins
export const LINK_TO_PROTEIN_ANNOTATION_PADDING = 1;
export const LINK_TO_PROTEIN_ANNOTATION_HEIGHT = 16;
export const LINK_TO_PROTEIN_ANNOTATION_VMARGIN = 2;
export const LINK_TO_PROTEIN_ARROW_TIP_HEIGHT = 8;
export const LINK_TO_PROTEIN_ARROW_CIRCLE_RADIUS = 2;
export const LINK_TO_PROTEIN_DOT_SPACING = 12;

export interface BiointelligentLinkHighlightRegion {
  start: number;
  end: number;
  highlightFillColor: string;
  linkType: BiointelligentLinkType;
  // TODO (BNCH-124222): Add a strand field (forward, reverse, or both)
}

export interface ViewBiointelligentLinkData {
  id: number;
  color: string;
  start: number;
  end: number;
  name: string;
  isArchived: boolean;
  outOfSync: boolean;
  linkType: BiointelligentLinkType;
}
